import { createListViewComponent } from 'factories/ListView'
import entityNames from 'options/entityNames'
import Filter from 'containers/LabelTemplates/Filter'

export default createListViewComponent({
  entityName: entityNames.labelTemplates,
  createButtonTextId: 'createLabelTemplate',
  primaryLinkTarget: 'labelTemplateRecord',
})(Filter)
